export default __webpack_public_path__ + "static/media/ultralight.1bde301e.png";